import React from 'react'
import intl from 'react-intl-universal'

import { LineConfig } from '~/types'

export type FieldNames = 'unit' | 'value' | 'linesPerInch'

const initialFieldErrors = {
  value: '',
  linesPerInch: '',
}

export default function useLineForm(
  lineConfig: LineConfig = {
    unit: null,
    value: null,
    linesPerInch: null,
  }
) {
  const [isFormValid, setIsFormValid] = React.useState(true)
  const [fields, setFields] = React.useState<LineConfig>(lineConfig)
  const [fieldErrors, setFieldErrors] = React.useState<
    { [key in FieldNames]?: string }
  >(initialFieldErrors)

  const handleFieldChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget
    setFields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }))
  }

  const validate = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { unit, ...textFields } = fields

    const nextFieldErrors = Object.entries(textFields).reduce(
      (acc, [name, value]) => {
        let error = ''
        if (value && !/^\d+$/.test(value)) {
          error = intl.get('LineConfiguration.tabs.default.errors.numeric')
        } else if (Number(value) > 500) {
          error = intl.get('LineConfiguration.tabs.default.errors.maximum')
        }

        return {
          ...acc,
          [name]: error,
        }
      },
      fieldErrors
    )

    const isValid = !Object.values(nextFieldErrors).some(Boolean)

    setFieldErrors(nextFieldErrors)
    setIsFormValid(isValid)
    return isValid
  }

  const reset = () => {
    setFields(lineConfig)
    setFieldErrors(initialFieldErrors)
  }

  return {
    fields,
    fieldErrors,
    handleFieldChange,
    validate,
    reset,
    isFormValid,
  }
}
